import React from "react";
import { Theme } from "@radix-ui/themes";
import { themeConfig } from "./customTheme";

/** Root Radix theme for the web app (single light theme). */
export const ThemeRoot: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <Theme {...themeConfig}>{children}</Theme>;
